import React from 'react'
import styled from '@emotion/styled'

import { fontSize3XSmall, fontFamilyOpenSans, highlightBlueBase } from '../../constants/principles'

export default ({ dealerIsDirectToKBBv2, kbbUrl = 'https://www.kbb.com' }) => (
  <StyledDiv data-nosnippet>
    {dealerIsDirectToKBBv2
      ? `This program involves selling directly to a Kelley Blue Book affiliate. Location restrictions apply. 
    Not all vehicles are eligible. The Offer amount may be less than the Kelley Blue Book® Trade-In Value or Range. 
    An inspection is required, and if the info you provide about the vehicle differs from the inspection, the Offer amount may be decreased.`
      : `Your Instant Cash Offer may be lower than the Kelley Blue Book Trade-In Range. For limitations, see the Kelley Blue Book `}
    <StyledA target= "_blank" href={`${kbbUrl}/company/terms-of-service/#termsAndConditions`}>Program Terms and Conditions</StyledA>.
  </StyledDiv>
)

const StyledA = styled.a`
  color: ${highlightBlueBase};
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`

const StyledDiv = styled.div`
  font-size: ${fontSize3XSmall};
  font-family: ${fontFamilyOpenSans};
  line-height: 17px;
  padding: 16px;
  width: 100%;
  text-align: center;
`
